import type {
  CtaButton,
  Document,
  Notification,
  Permission,
  PostType,
  Role,
  RootTerm,
  Site,
  Taxonomy,
} from '../../../Types'
import DocumentReducer from './DocumentReducer'
import NotificationReducer from './NotificationReducer'
import PermissionReducer from './PermissionReducer'
import PostTypeReducer from './PostTypeReducer'
import RolesReducer from './RolesReducer'
import SiteReducer from './SiteReducer'
import TaxonomiesReducer from './TaxonomiesReducer'
import TermReducer from './TermReducer'

interface IEntities {
  sites: Site[]
  postTypes: PostType[]
  documents: Document[]
  ctaButtons: CtaButton[]
  taxonomies: Taxonomy[]
  terms: RootTerm[]
  roles: Role[]
  permissions: Permission[]
  notifications: Notification[]
}

const initialState: IEntities = {
  sites: [],
  postTypes: [],
  documents: [],
  ctaButtons: [],
  taxonomies: [],
  terms: [],
  roles: [],
  permissions: [],
  notifications: [],
}

export default (state: IEntities = initialState, action) => {
  switch (action.type) {
    default:
      return {
        ...state,
        sites: SiteReducer(state.sites, action),
        postTypes: PostTypeReducer(state.postTypes, action),
        documents: DocumentReducer(state.documents, action),
        taxonomies: TaxonomiesReducer(state.taxonomies, action),
        terms: TermReducer(state.terms, action),
        roles: RolesReducer(state.roles, action),
        permissions: PermissionReducer(state.permissions, action),
        notifications: NotificationReducer(state.notifications, action),
      }
  }
}
